import { create } from "zustand";

export type AnimationPlayback = {
  available: string[];
  active: string | null;
  playing: boolean;
  loading: boolean;
  error: string | null;
};

const emptyPlayback = (): AnimationPlayback => ({ available: [], active: null, playing: false, loading: false, error: null });

interface AnimationState {
  byObjectId: Record<string, AnimationPlayback>;
  registerAnimations: (objectId: string, names: string[]) => void;
  setLoading: (objectId: string, loading: boolean) => void;
  setError: (objectId: string, error: string | null) => void;
  playAnimation: (objectId: string, name: string) => void;
  stopAnimation: (objectId: string) => void;
  removeRuntime: (objectId: string) => void;
}

export const useAnimationStore = create<AnimationState>((set) => ({
  byObjectId: {},
  registerAnimations: (objectId, available) => set((state) => ({ byObjectId: { ...state.byObjectId, [objectId]: { ...(state.byObjectId[objectId] ?? emptyPlayback()), available, loading: false, error: null } } })),
  setLoading: (objectId, loading) => set((state) => ({ byObjectId: { ...state.byObjectId, [objectId]: { ...(state.byObjectId[objectId] ?? emptyPlayback()), loading } } })),
  setError: (objectId, error) => set((state) => ({ byObjectId: { ...state.byObjectId, [objectId]: { ...(state.byObjectId[objectId] ?? emptyPlayback()), loading: false, error } } })),
  playAnimation: (objectId, active) => set((state) => ({ byObjectId: { ...state.byObjectId, [objectId]: { ...(state.byObjectId[objectId] ?? emptyPlayback()), active, playing: true, error: null } } })),
  stopAnimation: (objectId) => set((state) => ({ byObjectId: { ...state.byObjectId, [objectId]: { ...(state.byObjectId[objectId] ?? emptyPlayback()), playing: false } } })),
  removeRuntime: (objectId) => set((state) => { const byObjectId = { ...state.byObjectId }; delete byObjectId[objectId]; return { byObjectId }; }),
}));
